import React from 'react';
import { Logo } from './Logo';
import { GOOGLE_REVIEWS_URL } from '../data/reviews';
import { SECTION_IDS, SectionId, scrollToSection } from '../utils/scroll';
const links: {
  label: string;
  id: SectionId;
}[] = [{
  label: 'Cómo funciona',
  id: SECTION_IDS.proceso
}, {
  label: 'Servicios',
  id: SECTION_IDS.servicios
}, {
  label: 'Testimonios',
  id: SECTION_IDS.testimonios
}, {
  label: 'Preguntas',
  id: SECTION_IDS.preguntas
}];
export function Footer() {
  return <footer className="bg-plum-900 text-ivory" data-id="element-40" data-mp="3ud7czjog16g0">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-14" data-id="element-41" data-mp="37o2ul235f8m">
        <div className="flex flex-col gap-9 sm:flex-row sm:items-start sm:justify-between sm:gap-16" data-id="element-42" data-mp="3leviv7odbqit">
          <div data-id="element-43" data-mp="3qcx86ace0m2q">
            <Logo tone="light" data-id="element-44" data-mp="3qcduj5trsjui" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-lavender-200/90" data-id="element-45" data-mp="3qfji2gmr3do4">
              Consultoría y creación de negocios en Florida: estructura, identidad y
              presencia digital.
            </p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 sm:gap-16" data-id="element-46" data-mp="3l9ahbtogro9p">
            <nav aria-label="Secciones" className="grid gap-3" data-id="element-47" data-mp="3lbmu7sfd78fw">
              <p className="eyebrow text-lavender-300" data-id="element-48" data-mp="3gbr0cm0dsxe2">Explorar</p>
              {links.map(link => <button key={link.id} type="button" onClick={() => scrollToSection(link.id)} className="text-left text-sm text-lavender-200/90 transition-colors duration-200 ease-premium hover:text-ivory" data-id="element-49" data-mp="3v8htidjgpcv8">
                  {link.label}
                </button>)}
            </nav>

            <div className="grid gap-3" data-id="element-50" data-mp="hrs8biwygb7p">
              <p className="eyebrow text-lavender-300" data-id="element-51" data-mp="huwg0q9mpp34">Confianza</p>
              <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-analytics-id="google-reviews-footer" className="text-sm text-lavender-200/90 transition-colors duration-200 ease-premium hover:text-ivory" data-id="element-52" data-mp="cv1r2s9ez9kp">
                Reseñas en Google
              </a>
              <p className="text-sm text-lavender-200/70" data-id="element-53" data-mp="ytejef2si8ro">Negocios en Florida</p>
            </div>
          </div>
        </div>

        <div className="mt-10 h-px w-full bg-lavender-300/25" data-id="element-54" data-mp="13rpsgnl9gf8u" />

        <p className="mt-6 text-xs text-lavender-200/70" data-id="element-55" data-mp="18kitb0dlz3fn">
          © {new Date().getFullYear()} Inkova Business Consulting &amp; Creation.
        </p>
      </div>
    </footer>;
}